module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/374.515672b4.png";